import React, { useEffect, useState } from "react"
import API from "../../api"
import Button from "../../components/button"

// screens
import CardCreate from "../../pages/cards/create"

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"

import Card from "../../components/card"
import useInfiniteScroll from "../../hooks/useInfiniteScroll"
import { useNavigate } from "react-router-dom"
import { useLanguage } from "@languages/index"
import { Elements as StripeElements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { Elements as MulpayElements } from "@mul-pay/mptoken-react-js"

const stripePromise = loadStripe(process.env.STRIPE_PUBLIC_KEY)


const CardIndex = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.cards }

  const navigate = useNavigate()


  const [mulpayPromise, setMulpayPromise] = useState<Promise<any> | null>(null);


  const [cards, setCards] = useState([])

  const [isFetchFinished, setIsFetchFinished] = useState(false)
  const [isContentEnded, setIsContentEnded] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)

  const [isFetching, setIsFetching] = useInfiniteScroll(() => {
    if (cards.length) {
      fetchCards()
    }
  })

  useEffect(() => {
    if (!cards.length && !isContentEnded) {
      fetchCards(true)
    }
  }, [cards])

  
  // MOUNT MULPAY
  useEffect(() => {
    let isMounted = true;
 
    const loadMulpayModule = async () => {
      try {
        const { loadMulpay } = await import('@mul-pay/mptoken-js');
        if (isMounted) {
          const apiKey = process.env.GMO_API_KEY
          const publicKey = process.env.GMO_PUBLIC_KEY
          const merchantIds = {
            // googlePayMerchantId: "01234567890123456789"
          }
          const promise = loadMulpay(apiKey, publicKey, undefined, true, true);
          setMulpayPromise(promise);
        }
      } catch (error) {
        console.error('Failed to load mulpay module', error);
      }
    };
 
    loadMulpayModule();
 
    return () => {
      isMounted = false;
    };
  }, []);


  const fetchCards = (refresh?: Boolean) => {
    if (isContentEnded && !refresh) {
      return false
    }

    const targetPage = refresh ? 1 : currentPage

    API.Card.index({
      ...{
        brandToken: props.auth.token,
        page: targetPage,
      },
    })
      .then((response) => {
        const fetchedCards = response.data.cards.data
        setCards(targetPage === 1 ? fetchedCards : cards.concat(fetchedCards))

        setCurrentPage(targetPage + 1)
        setIsFetchFinished(true)

        if (response.data.cards.currentPage == response.data.cards.lastPage) {
          setIsContentEnded(true)
        }

        setIsFetching(false)
      })
      .catch((error) => {
        props.showModal({ text: error.message })
      })
  }

  const renderPageTitle = () => {
    return (
      <div className="flex flex-row mb-2 justify-between">
        <div className="flex flex-col">
          <span className="font-bold text-xl tracking-tighter">{languageTexts.payment_info}</span>
        </div>

        <div className="flex flex-col">
          {isFetchFinished && cards.length > 0 ? (
            <span
              className="text-[#999999] text-[13px] tracking-tighter underline cursor-pointer"
              onClick={() => {
                props.preferences.isMobile
                  ? props.setSheet({
                      isVisible: true,
                      maxHeight: "100%",
                      content: () => {
                        return renderCreateCardScreen()
                      },
                    })
                  : props.setModal({
                      isVisible: true,
                      maxHeight: "80dvh",
                      content: () => {
                        return renderCreateCardScreen()
                      },
                    })
              }}
            >
              {languageTexts.payment_card_update}
            </span>
          ) : null}
        </div>
      </div>
    )
  }

  const renderCards = () => {
    if (isFetchFinished && cards.length == 0) {
      return (
        <div className="py-10 flex flex-col justify-center w-full items-center">
          <div className="mx-5 flex">
            <span className="prose prose-xl text-slate-500">{languageTexts.index_text_1}</span>
          </div>
        </div>
      )
    }

    return (
      <div className="items-center max-w-sm min-w-sm">
        {cards.map((card) => {
          return (
            <Card
              key={`Card${card.id}`}
              card={card}
              onCardUpdated={() => {
                fetchCards(true)
              }}
            />
          )
        })}
      </div>
    )
  }

  const renderCreateCardScreen = () => {
    const titleStyle = {
      fontWeight: 700,
      fontSize: "22px",
      lineHeight: "27px",
      letterSpacing: "-0.05em",
    }

    return (
      <div
        className="relative w-[100dvw] md:w-[480px] flex flex-col px-5 py-6 md:px-[50px] md:py-[50px] bg-white overflow-scroll pb-[100px] md:pb-0 md:rounded-2xl"
        style={{
          minWidth: 370,
        }}
      >
        <div className="flex flex-col">
          <div className="flex flex-row mb-2">
            <span style={titleStyle}>{languageTexts.index_text_2}</span>
          </div>
        </div>
        
        {(mulpayPromise != null && stripePromise != null) && (
          <MulpayElements multiPayment={mulpayPromise}>
            <StripeElements stripe={stripePromise}>
              <CardCreate
                onCardCreated={() => {
                  navigate("/cards")
                  props.closeOverlays()
                  fetchCards(true)
                }}
                onClose={() => {
                  props.closeOverlays()
                  fetchCards(true)
                }}
              />
            </StripeElements>
          </MulpayElements>
        )}
      </div>
    )
  }

  const renderCreateCardButton = () => {
    if (!isFetchFinished) return null
    if (isFetchFinished && cards.length > 0) return null

    return (
      <div className="flex flex-col justify-center items-center">
        <div className="mx-5 mt-5 flex w-full max-w-sm min-w-sm">
          <Button
            text={languageTexts.index_text_4}
            buttonColor={"BLACK"}
            borderColor={"BLACK"}
            textColor={"WHITE"}
            onClick={() => {
              props.preferences.isMobile
                ? props.setSheet({
                    isVisible: true,
                    maxHeight: "100%",
                    content: () => {
                      return renderCreateCardScreen()
                    },
                  })
                : props.setModal({
                    isVisible: true,
                    maxHeight: "80dvh",
                    content: () => {
                      return renderCreateCardScreen()
                    },
                  })
            }}
          />
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="px-5 py-6 xl:px-10 pb-10 mx-auto max-w-[385px]">
        {renderPageTitle()}
        <div className="flex flex-col">
          {renderCards()}
          {renderCreateCardButton()}
        </div>
      </div>
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(CardIndex)
